import type { IMeasurementsType } from "@medoma/models/activities";
import { measurementsDictionary } from "@medoma/models/activities";
import { useLingui } from "@lingui/react/macro";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import styles from "./MeasurementChip.module.scss";

const MeasurementChip = ({
  measurement,
  size,
}: {
  measurement: IMeasurementsType;
} & Pick<Parameters<typeof Chip>[0], "size">) => {
  const { t } = useLingui();
  return (
    <CustomProperties className={styles[measurement]}>
      <Chip background={"solid"} border={"none"} size={size} shape={"sharp"}>
        {t(measurementsDictionary[measurement])}
      </Chip>
    </CustomProperties>
  );
};

export default MeasurementChip;
